import api from '@/services/api'
import useLoading from '@/composables/useLoading'
import useResponse from '@/composables/useResponse'
import { computed, ref, watch } from '@vue/composition-api'

export default function useProduct() {
  const list = ref([])
  const pagination = ref({
    page: 1,
    perPage: 10,
    totalPage: 1,
  })

  const { isLoading, startLoading, finishLoading } = useLoading()

  const tableColumns = [
    { key: 'id', label: '#' },
    { key: 'image', label: 'Image' },
    { key: 'name', label: 'Name' },
    { key: 'position', label: 'Position' },
    { key: 'sizes', label: 'Sizes', formatter: sizes => sizes.reduce((acc, s) => `${acc}, ${s.size}`, '').slice(1) },
    { key: 'actions', label: 'Actions' },
  ]

  const paginationMeta = computed(() => ({
    from: pagination.value.perPage * (pagination.value.page - 1) + (list.value.length ? 1 : 0),
    to: pagination.value.perPage * (pagination.value.page - 1) + list.value.length,
    of: pagination.value.totalPage,
  }))

  // eslint-disable-next-line no-use-before-define
  watch(() => pagination.value.page, findAll)

  async function findAll() {
    try {
      startLoading()
      const response = useResponse(
        await api.product.findAll({
          params: {
            page: pagination.value.page,
            limit: pagination.value.perPage,
          },
        }),
      )
      list.value = response.documents
      pagination.value.totalPage = response.pagination.totalPage
    } finally {
      finishLoading()
    }
  }

  function findOne({ id }) {
    return api.product.findOne({ id })
  }

  function create({ body }) {
    const formData = new FormData()
    formData.append('image', body.image)
    formData.append('position', body.position)
    formData.append('name', JSON.stringify(body.name))
    formData.append('sizes', JSON.stringify(body.sizes))
    formData.append('description', JSON.stringify(body.description))
    return api.product.create(formData)
  }

  function edit({ id, body }) {
    return api.product.edit({ id, body })
  }

  return {
    list,
    pagination,
    paginationMeta,
    tableColumns,
    isLoading,

    create,
    edit,
    findOne,
    findAll,
  }
}
